// Simple Shopify Theme JavaScript

// Document ready function
document.addEventListener('DOMContentLoaded', function() {
  initLoadingSection();
  initQuantitySelectors();
  initAjaxCart();
  initCartDrawer();
  initMobileMenu();
  initLanguageSwitcher();
  collectionNavigationFiltering();
});

// Initialize loading section
function initLoadingSection() {
  const loadingSection = document.querySelector('.loading');
  if (!loadingSection) return;

  // Hide loading section after animation completes
  window.addEventListener('load', function() {
    setTimeout(() => {
      loadingSection.style.opacity = '0';
      setTimeout(() => {
        loadingSection.style.display = 'none';
      }, 300);
    }, 2400); // Pattern animations duration
  });
}

// Initialize quantity selectors on product pages
function initQuantitySelectors() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  if (!quantitySelectors.length) return;
  
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('input');
    const increaseBtn = selector.querySelector('.increase');
    const decreaseBtn = selector.querySelector('.decrease');
    
    if (increaseBtn) {
      increaseBtn.addEventListener('click', function() {
        input.value = parseInt(input.value) + 1;
      });
    }
    
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        const newValue = parseInt(input.value) - 1;
        input.value = newValue > 0 ? newValue : 1;
      });
    }
  });
}

// Initialize Cart Drawer
function initCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  const cartDrawerTrigger = document.querySelector('.cart-drawer-trigger');
  const cartDrawerClose = document.querySelector('.cart-drawer-close');
  
  if (!cartDrawer || !cartDrawerOverlay || !cartDrawerTrigger || !cartDrawerClose) return;
  
  // Open cart drawer
  cartDrawerTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    openCartDrawer();
  });
  
  // Close cart drawer with close button
  cartDrawerClose.addEventListener('click', closeCartDrawer);
  
  // Close cart drawer with overlay
  cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  
  // Handle quantity updates in drawer
  const quantitySelectors = cartDrawer.querySelectorAll('.quantity-selector');
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('input');
    const increaseBtn = selector.querySelector('.increase');
    const decreaseBtn = selector.querySelector('.decrease');
    
    if (input) {
      input.addEventListener('change', function() {
        updateCartFromDrawer();
      });
    }
  });
  
  // Handle drawer remove items
  const removeButtons = cartDrawer.querySelectorAll('.cart-drawer-item-remove');
  removeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const lineNumber = this.getAttribute('data-line');
      
      if (lineNumber) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineNumber),
            quantity: 0
          })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          refreshCartDrawer();
          updateCartCount();
        })
        .catch(error => {
          console.error('Error removing item:', error);
          refreshCartDrawer();
          updateCartCount();
        });
      }
    });
  });
  
  // Handle form submission
  const cartForm = cartDrawer.querySelector('.cart-drawer-form');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      if (e.submitter && e.submitter.name !== 'checkout') {
        e.preventDefault();
        updateCartFromDrawer();
      }
    });
  }
}

// Open cart drawer
function openCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  
  if (!cartDrawer || !cartDrawerOverlay) return;
  
  cartDrawer.classList.add('active');
  cartDrawerOverlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

// Close cart drawer
function closeCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  
  if (!cartDrawer || !cartDrawerOverlay) return;
  
  cartDrawer.classList.remove('active');
  cartDrawerOverlay.classList.remove('active');
  document.body.style.overflow = '';
}

// Update cart from drawer inputs
function updateCartFromDrawer() {
  const cartForm = document.querySelector('.cart-drawer-form');
  if (!cartForm) return;
  
  const formData = new FormData(cartForm);
  
  fetch('/cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(cart => {
    refreshCartDrawer();
    updateCartCount();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

// Refresh cart drawer contents
function refreshCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('#cart-drawer');
      
      if (newCartDrawer) {
        const currentCartDrawer = document.querySelector('#cart-drawer');
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        
        // Reinitialize drawer functionality
        initCartDrawer();
      }
    })
    .catch(error => {
      console.error('Error refreshing cart drawer:', error);
    });
}

// Initialize Ajax cart functionality
function initAjaxCart() {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  if (!addToCartForms.length) return;
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        updateCartCount();
        showCartNotification('Item added to cart');
        // Open cart drawer after adding item
        openCartDrawer();
        refreshCartDrawer();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        showCartNotification('Error adding to cart', true);
      });
    });
  });
}

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    });
}

// Show cart notification
function showCartNotification(message, isError = false) {
  let notification = document.querySelector('.cart-notification');
  
  if (!notification) {
    notification = document.createElement('div');
    notification.className = 'cart-notification';
    document.body.appendChild(notification);
  }
  
  notification.textContent = message;
  notification.classList.toggle('error', isError);
  notification.classList.add('active');
  
  setTimeout(() => {
    notification.classList.remove('active');
  }, 3000);
}

// Initialize mobile menu functionality
function initMobileMenu() {
  if (window.innerWidth < 768) {
    const mainMenuLinks = document.querySelectorAll('.main-menu-link');
    
    mainMenuLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const menuItem = this.parentNode;
        const submenu = menuItem.querySelector('.submenu');
        
        if (submenu && !submenu.classList.contains('active')) {
          e.preventDefault();
          submenu.classList.add('active');
          submenu.style.display = 'block';
          
          // Close when clicking outside
          const closeSubmenu = function(event) {
            if (!menuItem.contains(event.target)) {
              submenu.classList.remove('active');
              submenu.style.display = '';
              document.removeEventListener('click', closeSubmenu);
            }
          };
          
          setTimeout(() => {
            document.addEventListener('click', closeSubmenu);
          }, 0);
        }
      });
    });
  }
}

// Initialize language switcher
function initLanguageSwitcher() {
  // No custom JS needed for language links - letting the default link behavior work
  // Links are already formatted correctly in theme.liquid
}

// Collection navigation filtering
function collectionNavigationFiltering() {
  const collectionLinks = document.querySelectorAll('.collection-link');
  
  collectionLinks.forEach(link => {
    const collectionTitle = link.textContent.trim().toLowerCase();
    
    // Only show "All" link and collections with "edition" in the title
    if (collectionTitle === 'all' || collectionTitle.includes('edition')) {
      link.style.display = 'inline-block';
    } else {
      link.style.display = 'none';
    }
  });
}

// Header scroll effect
let lastScrollPosition = 0;
const header = document.querySelector('header');
const scrollThreshold = 50; // 스크롤 거리 임계값

function handleHeaderScroll() {
  const currentScrollPosition = window.pageYOffset;
  
  // 스크롤 방향 확인
  if (currentScrollPosition > lastScrollPosition && currentScrollPosition > scrollThreshold) {
    // 아래로 스크롤: 헤더 숨기기
    header.classList.add('hide');
  } else {
    // 위로 스크롤 또는 최상단 근처: 헤더 보이기
    header.classList.remove('hide');
  }
  
  lastScrollPosition = currentScrollPosition;
}

// 스크롤 이벤트 리스너 등록
window.addEventListener('scroll', handleHeaderScroll); 